<template>
<div class="wrapper">
  <div class="row">
    <div class="col-lg-12">
      <div id="filters">
        <div class="search col-lg-12 col-md-12">
          <div class="row">
            <div class="col-lg-3 col-md-3 m-t-sm">
              <v-select
                placeholder="Clients"
                :options="f.clients"
                label="name"
                index="id"
                multiple
                v-model="filters['clients']"
              ></v-select>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <button class="btn btn-xs btn-primary" @click="loadIssues">Search</button>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12">
      <table class="hover table">
        <thead>
        <tr>
          <th>Pbn</th>
          <th>Client</th>
          <th>Group</th>
          <th>Assigned IP</th>
          <th>Resolved IP</th>
          <th>Resolved WWW</th>
          <th>Resolved DNS</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="pbn in issues" :key="pbn.id">
          <td><router-link :to="'/pbn/' + pbn.punyDomain">{{ pbn.domain }}</router-link></td>
          <td>{{ pbn.client.name }}</td>
          <td>{{ pbn.group ? pbn.group.name : '/' }}</td>
          <td>{{ pbn.integrations.hosting.ip.ip_address }}</td>
          <td
            :class="pbn.integrations.hosting.ip.ip_address === pbn.integrations.hosting.health.resolved_ip_address ? 'green' : 'red'"
          >{{ pbn.integrations.hosting.health.resolved_ip_address || '/'}}</td>
          <td
            :class="pbn.integrations.hosting.ip.ip_address === pbn.integrations.hosting.health.resolved_www_ip_address ? 'green' : 'red'"
          >{{ pbn.integrations.hosting.health.resolved_www_ip_address || '/' }}</td>
          <td
            :class="pbn.dnsData && pbn.dnsData.A && pbn.dnsData.A[0].ip === pbn.integrations.hosting.ip.ip_address ? 'green' : 'red'"
          >
            <span v-if="pbn.dnsData && pbn.dnsData.A">{{ pbn.dnsData.A[0].ip }}</span>
            <span v-else>/</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      issues: [],
      filters: {}
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Query],
  methods: {
    loadIssues () {
      axios.get('/hosting/priority-prospect/dns-issues?' + this.buildQuery(this.filters))
        .then(r => {
          this.issues = r.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/DnsIssues.vue